import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import {
    useSiteSettings,
    useContentSection,
    useGallery,
    instaUrlFrom,
} from "@/lib/siteData";

export default function Contato() {
    const settings = useSiteSettings();
    const sec = useContentSection("contato");
    const gallery = useGallery();

    const av = (() => {
        if (settings.availability_status === "consulta")
            return {
                text: settings.availability_message || "Somente sob consulta",
                cls: "border-neon-sun/40 bg-neon-sun/10 text-neon-sun",
            };
        if (settings.availability_status === "indisponivel")
            return {
                text:
                    settings.availability_message ||
                    "Indisponível no momento",
                cls: "border-neon-coral/40 bg-neon-coral/10 text-neon-coral",
            };
        if (settings.availability_message)
            return {
                text: settings.availability_message,
                cls: "border-neon-teal/40 bg-neon-teal/10 text-neon-teal",
            };
        return null;
    })();

    return (
        <section id="contato" className="relative py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.15 }}
                    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    className="relative overflow-hidden rounded-[2.5rem] border border-neon-cyan/20 bg-deep px-7 py-14 text-center sm:px-12"
                    data-testid="contato-cta-card"
                >
                    <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-neon-cyan/10 blur-3xl" />
                    <p className="font-mono2 text-[11px] font-semibold uppercase tracking-[0.3em] text-neon-cyan">
                        {sec.extra.label}
                    </p>
                    <h2 className="mx-auto mt-5 max-w-2xl font-display text-3xl font-black uppercase leading-tight text-ink sm:text-5xl">
                        {sec.title}
                    </h2>
                    <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-dim">
                        {sec.subtitle}
                    </p>
                    {av && (
                        <p
                            data-testid="availability-chip"
                            className={`mx-auto mt-6 inline-block rounded-full border px-5 py-2 font-mono2 text-[10px] font-semibold uppercase tracking-[0.25em] ${av.cls}`}
                        >
                            {av.text}
                        </p>
                    )}
                    <div className="mt-9 flex flex-wrap items-center justify-center gap-4">

                        <a
                            href={instaUrlFrom(settings)}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="contato-instagram"
                            className="inline-flex items-center gap-2 rounded-full border border-ink/25 px-8 py-4 font-display text-xs font-extrabold uppercase tracking-widest text-ink transition-colors duration-300 hover:border-neon-cyan hover:text-neon-cyan"
                        >
                            <Instagram className="h-4 w-4" />
                            {settings.instagram_handle}
                        </a>
                    </div>

                    <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-3">
                        {gallery.map((f) => (
                            <div
                                key={f.id}
                                className="group relative h-44 overflow-hidden rounded-2xl border border-ink/10"
                            >
                                <img
                                    src={f.url}
                                    alt={f.alt}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                            </div>
                        ))}
                    </div>

                    <p className="mt-8 font-mono2 text-[10px] font-semibold uppercase tracking-[0.3em] text-dim">
                        {sec.extra.note}
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
